import {ActionLocal} from './actions.service';
import {type} from '../../common/utils';
import {FeatureEx} from "../../models/features/features";
import {IInput, IOutput, ISingleOutput, ISpec} from "../../models/ISpec";
import {IBounds, IEntityAlert, ILedInfo} from "../../models/common";

export class ApplicationSpecActions {

  static ActionType = {
    SET_FEATURES_FILTER: type('[ApplicationSpecActions] SET_FEATURE_FILTER'),
    UPDATE_FEATURE_FILTER: type('[ApplicationSpecActions] UPDATE_FEATURE_FILTER'),
    INPUT_SET_VALUE: type('[ApplicationSpecActions] INPUT_SET_VALUE'),
//    INPUT_SET_NOTE: type('[ApplicationSpecActions] INPUT_SET_NOTE'),
    OUTPUT_ADD: type('[ApplicationSpecActions] OUTPUT_ADD'),
    OUTPUT_REMOVE: type('[ApplicationSpecActions] OUTPUT_REMOVE'),
    OUTPUT_SET_VALUE: type('[ApplicationSpecActions] OUTPUT_SET_VALUE'),
    SINGLE_OUTPUT_SET_VALUE: type('[ApplicationSpecActions] SINGLE_OUTPUT_SET_VALUE'),
//    SINGLE_OUTPUT_SET_NOTE: type('[ApplicationSpecActions] SINGLE_OUTPUT_SET_NOTE'),
    SET_NOTES: type('[ApplicationSpecActions] SET_NOTES'),
    // GLOBAL_OUTPUT_SET_NOTE: type('[ApplicationSpecActions] GLOBAL_OUTPUT_SET_NOTE'),
    RESET_SPECS: type('[ApplicationSpecActions] RESET_SPECS'),
    VALIDATE_SPECS: type('[ApplicationSpecActions] VALIDATE_SPECS'),
    UPDATE_OUTPUTS_BOUNDS: type('[ApplicationSpecActions] UPDATE_OUTPUTS_BOUNDS'),
    SELECT_LED: type('[ApplicationSpecActions] SELECT_LED'),
    EDIT_SPEC: type('[ApplicationSpecActions] EDIT_SPEC'),
  };

  public static setFeaturesFilter(features: FeatureEx[]): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.SET_FEATURES_FILTER, payload: features};
  }

  public static resetSpec(): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.RESET_SPECS};
  }

  public static validateSpecs(): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.VALIDATE_SPECS};
  }

  public static updateOutputsBoundsSpec(bounds: IBounds): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.UPDATE_OUTPUTS_BOUNDS, payload: bounds};
  }

  public static updateFeature(feat: FeatureEx): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.UPDATE_FEATURE_FILTER, payload: feat};
  }

  public static setInputLimits(i: IInput<number>): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.INPUT_SET_VALUE, payload: i};
  }

  public static addOutput(): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.OUTPUT_ADD};
  }

  public static removeOutput(idx: number): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.OUTPUT_REMOVE, payload: idx};
  }

  public static setOutputValue(val: IOutput<number>) {
    return {type: ApplicationSpecActions.ActionType.OUTPUT_SET_VALUE, payload: val};
  }

  public static setSingleOutput(idx: number, o: ISingleOutput<number>): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.SINGLE_OUTPUT_SET_VALUE, payload: {index: idx, output: o}};
  }

  public static setGlobalNote(n: ISpec<IEntityAlert>, g: IEntityAlert): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.SET_NOTES, payload: {note: n, globalNote: g}};
  }

  public static setSelectedLed(led: ILedInfo): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.SELECT_LED, payload: led};
  }

  public static editSpec(edited: boolean): ActionLocal {
    return {type: ApplicationSpecActions.ActionType.EDIT_SPEC, payload: edited};
  }
}
